











































































































































































































































































































import FeedbackComponent from '@/components/base/FeedbackComponent'
import MemberAccountsGrid from "@/components/dashboard/customer-service/components/MemberAccountsGrid.vue";
import MemberSubAccountsGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberSubAccountsGrid.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {EmployerCRMDetails, MemberCRMDetails} from "@/store/modules/customerService";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({
  components: {
    MemberSubAccountsGrid,
    MemberAccountsGrid
  }
})
export default class CustomerServiceCRMContactGeneralDetails extends FeedbackComponent {

  @Prop(Number) crmId!: number;
  @Prop() memberCRMDetails!: MemberCRMDetails
  @Prop() employerCRMDetails!: EmployerCRMDetails

  @Action('getCRMContact', StoreNamespace.CUSTOMER_SERVICE) getCRMContact: any;
  @Action('getSubAccounts', StoreNamespace.CUSTOMER_SERVICE) getSubAccounts: any;

  private contactData = null
  private memberSubAccounts: any = null
  private selectedAccountNum: string = ""
  private showSubAccountSpinner: boolean = false;

  mounted() {

    if (this.crmId > 0) {
      this.getCRMContact({
        pathVariable: this.crmId,
        requestorCallback: this
      });
    }
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'CRMContacts' :
        this.contactData = data;
        break;
      case 'findMembersOrEmployersFor/subAccounts':
        this.showSubAccountSpinner = false;
        this.memberSubAccounts = data
        break;
    }
  }


  private onSelectedMemberAccount(accountDetails: any) {
    this.memberSubAccounts = null
    this.selectedAccountNum = accountDetails.accountNum
    this.showSubAccountSpinner = true

    this.getSubAccounts({
      pathVariable: accountDetails.accountNumHashed,
      requestorCallback: this
    })
  }
}


